import axios from "axios";

interface Data {
  id: string;
  companyId: string;
  companyLocationId: string;
  moduleId: string;
  moduleName: string;
  badgeType?: string;
  invoiceDate: number;
}
export interface Licenses {
  data: Data[];
  success: boolean;
}

export interface addOrUpdateLicense {
  companyId: string;
  companyLocationId: string;
  moduleId: string;
  invoiceDate: number;
}

export async function getAllLicenses() {
  return axios
    .get<Licenses[]>("Licenses/getalllicenses")
    .then((res) => res.data);
}

export async function getLicensesByLocation(CompanyLocationId: string) {
  return axios
    .get<Licenses>(`Licenses/getalllicensesbylocation`, {
      params: { CompanyLocationId },
    })
    .then((res) => res.data);
}

export async function addLicense(licenseCredentials: addOrUpdateLicense) {
  return axios
    .post(`Licenses/addlicense`, licenseCredentials)
    .then((res) => res.data);
}

export async function updateLicense(licenseCredentials: addOrUpdateLicense) {
  return axios
    .post(`Licenses/updatelicense`, licenseCredentials)
    .then((res) => res.data);
}

export async function deleteLicense(id: string) {
  return axios.post(`Licenses/deletelicense`, { id }).then((res) => res.data);
}
